import React, { useEffect, useState } from "react";
import Text from "@gc-npm/components.text";
import Image from "@gc-npm/components.c-image";
import Price from "@gc-npm/components.price";
import Button from "@gc-npm/components.button";
import CustomLink from "@gc-npm/components.custom-link";
import Label from "@gc-npm/components.label";
import getDeviceKindDependsOnViewPort from "@gc-npm/utils.common.get-device-kind-depends-on-viewport";
import Video from "./video-component";
const makeUpComoponentPerso = (taggingInfo) => {
  if (taggingInfo && taggingInfo.componentPerso) {
    return JSON.stringify(taggingInfo.componentPerso);
  }
  return "";
};

function videoSelection(props) {
  const videoMobile = props["Video-3"];
  const videoTablet = props["Video-2"];
  const videoDesktop = props["Video-1"];

  let video = null;
  const device = getDeviceKindDependsOnViewPort();
  if (device === "MOBILE") {
    video = videoMobile;
  } else if (device === "TABLET") {
    video = videoTablet;
  } else {
    video = videoDesktop;
  }
  return video;
}
function SuperBanner(props) {
  const imageMobile = props["Image-3"];
  const imageTablet = props["Image-2"];
  const imageDesktop = props["Image-1"];
  const [video, setVideo] = useState(null);
  useEffect(() => {
    const video = videoSelection(props);
    setVideo(video);
  });

  let taggingInfo;
  try {
    taggingInfo = props.taggingInfo && {
      ...props.taggingInfo,
      componentPerso: makeUpComoponentPerso(props.taggingInfo),
      eventType: "click",
      componentContent: "contratar",
    };
  } catch (err) {}

  const hasBackgroundVideo = props["Video-2"] && props["Video-2"].src;

  const layoutCompact = props?.layout === "compact";
  const layoutMini = props?.layout == "mini";
  const layoutBackgroundFull = props?.layout == "bgfull";
  const hastImageMobileTwo =
    props["ImageMobile-2"] && props["ImageMobile-2"]?.src;

  const component = props["Component"];
  let link = null;
  if (layoutMini) {
    link = props["CustomLink-1"];
  }

  if (!component || component == "") {
    return null;
  }

  const imgBackgroundLinear = { background: `background: linear-gradient(90deg,rgb(88, 42, 42, 0),${props?.["background-color"] || "rgba(245, 245, 245, 1)"},${props?.["background-color"] || "rgba(245, 245, 245, 1)"})`}

  return (
    <>
      <div className="super container">
        {layoutMini && (
          <div className="minibanner">
            <CustomLink {...link} />
            {imageMobile && imageMobile.src && !video && (
              <div className="image-mobile">
                <Image
                  fill
                  cyData="minibanner image-mobile"
                  {...imageMobile}
                />
              </div>
            )}
            {imageTablet && imageTablet.src && !video && (
              <div className="image-tablet">
                <Image
                  fill
                  className="image-tablet"
                  cyData="minibanner image-tablet"
                  {...imageTablet}
                />
              </div>
            )}
            {imageDesktop && imageDesktop.src && !video && (
              <div className="image-desktop">
                <Image
                  fill
                  className="image-desktop"
                  cyData="minibanner image-desktop"
                  {...imageDesktop}
                />
              </div>
            )}
            {video && video?.src && (
              <div className="video-background">
                <Video {...video} expand={false} width="100%" height="100%" />
              </div>
            )}
            <div className={`${props?.skeletonClassName}`}></div>
          </div>
        )}

        {layoutCompact && (
          <>
            <CustomLink
              {...props["CustomLink-1"]}
              taggingInfo={taggingInfo}
            />
            <div className={`superbanner row ${layoutCompact? 'compact' : 'no-compact'}`} style={{backgroundColor: props?.["background-color"] || "#f5f5f5"}}>
              <div
                className={`col-md-5 col-sm-5 col-xs-12 ${hasBackgroundVideo ? "video-cont" : "img-cont"} ${layoutCompact? 'compact' : 'no-compact'}`}
              >
                {!hastImageMobileTwo &&
                  props["Image-2"] &&
                  props["Image-2"]?.src && (
                    <div className="img-background">
                      <Image
                        {...props["Image-2"]}
                        width={2000}
                        height={2000}
                      />
                      {props["Image-2"] &&
                        props["Image-2"]?.["linear-gradient"] && (
                          <div className="img-background-linear-gradient" style={imgBackgroundLinear} />
                        )}
                    </div>
                  )}

                {hastImageMobileTwo && (
                  <>
                    <div className="display--desktop">
                      {props["Image-2"] && props["Image-2"]?.src && (
                        <div className="img-background">
                          <Image
                            {...props["Image-2"]}
                            width={2000}
                            height={2000}
                          />
                          {props["Image-2"] &&
                            props["Image-2"]?.["linear-gradient"] && (
                              <div className="img-background-linear-gradient" style={imgBackgroundLinear}/>
                            )}
                        </div>
                      )}
                    </div>

                    <div className="display--mobile">
                      {props["ImageMobile-2"] &&
                        props["ImageMobile-2"]?.src && (
                          <div className="img-background">
                            <Image
                              {...props["ImageMobile-2"]}
                              width={2000}
                              height={2000}
                            />
                            {props["ImageMobile-2"] &&
                              props["ImageMobile-2"]?.["linear-gradient"] && (
                                <div className="img-background-linear-gradient" style={imgBackgroundLinear}/>
                              )}
                          </div>
                        )}
                    </div>
                  </>
                )}

                {props["Video-2"] && props["Video-2"]?.src && (
                  <div className="video-background">
                    <Video
                      {...props["Video-2"]}
                      expand={false}
                      width="100%"
                      height="100%"
                      objectFit="cover"
                    />
                    {props["Video-2"] &&
                      props["Video-2"]?.["linear-gradient"] && (
                        <div className="img-background-linear-gradient" style={imgBackgroundLinear}/>
                      )}
                  </div>
                )}

                {props["Image-1"] && props["Image-1"].src && (
                  <div className="main-image">
                    <Image
                      {...props["Image-1"]}
                      width={1285}
                      height={1000}
                      priority={true}
                    />
                  </div>
                )}
              </div>

              {layoutCompact || <div className="superbanner-separator" />}

              <div className={`content-container col-md-6 col-sm-6 col-xs-12 ${layoutCompact? 'compact' : 'no-compact'}`}>
                {props["LabelMobile-1"] && props["LabelMobile-1"].label && (
                  <div className="display--mobile">
                    <Label {...props["LabelMobile-1"]} />
                  </div>
                )}

                {props["Text-1"] && props["Text-1"].text && (
                  <Text {...props["Text-1"]} />
                )}

                {props["Text-2"] && props["Text-2"].text && (
                  <div className="superbanner-title">
                    <Text {...props["Text-2"]} />
                  </div>
                )}

                {props["Text-3"] && props["Text-3"].text && (
                  <div className="display--desktop">
                    <Text {...props["Text-3"]} />
                  </div>
                )}
                <div className="display--mobile">
                  {props["TextMobile-3"] && props["TextMobile-3"].text && (
                    <Text {...props["TextMobile-3"]} />
                  )}

                  <div className="superbanner-price-cont">
                    {props["Price-1"] && props["Price-1"].price && (
                      <Price {...props["Price-1"]} />
                    )}

                    {props["Price-2"] && props["Price-2"].price && (
                      <Price {...props["Price-2"]} />
                    )}
                  </div>
                  {props["Text-4"] && props["Text-4"].text && (
                    <Text {...props["Text-4"]} />
                  )}
                </div>

                <div className="display--desktop">
                  {props["Label-1"] && props["Label-1"]?.label && (
                    <Label {...props["Label-1"]} />
                  )}

                  <div className="superbanner-price-cont">
                    {props["Price-1"] && props["Price-1"].price && (
                      <Price {...props["Price-1"]} />
                    )}

                    {props["Price-2"] && props["Price-2"].price && (
                      <Price {...props["Price-2"]} />
                    )}
                  </div>
                </div>

                {props["Text-4"] && props["Text-4"].text && (
                  <div className="display--desktop">
                    <Text {...props["Text-4"]} />
                  </div>
                )}

                <div className="display--desktop">
                  {props["Button-1"] && props["Button-1"].href && (
                    <div className="superbanner-button-cont">
                      <Button
                        {...props["Button-1"]}
                        taggingInfo={taggingInfo}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="display--mobile">
              <div className="superbanner-price-cont-mobile">
                {props["PriceMobile-1"] && props["PriceMobile-1"]?.price && (
                  <Price {...props["PriceMobile-1"]} />
                )}

                {props["PriceMobile-2"] && props["PriceMobile-2"]?.price && (
                  <Price {...props["PriceMobile-2"]} />
                )}
              </div>
            </div>
            <div className={`${props?.skeletonClassName}`}>
              <div className="row skeleton-superbanner-cont">
                <div className="col-md-4 superbanner-post-card"></div>
                <div className="col-md-4 superbanner-post-card"></div>
                <div className="col-md-4 superbanner-post-card"></div>
              </div>
            </div>
          </>
        )}

        {layoutBackgroundFull && (
          <>
            <CustomLink {...props["CustomLink-1"]} />
            <div className="bgfull">
              {imageMobile && imageMobile.src && !video && (
                <div className="image-mobile">
                  <Image
                    fill
                    cyData="minibanner image-mobile"
                    {...imageMobile}
                  />
                </div>
              )}
              {imageTablet && imageTablet.src && !video && (
                <div className="image-tablet">
                  <Image
                    fill
                    className="image-tablet"
                    cyData="minibanner image-tablet"
                    {...imageTablet}
                  />
                </div>
              )}
              {imageDesktop && imageDesktop.src && !video && (
                <div className="image-desktop">
                  <Image
                    fill
                    className="image-desktop"
                    cyData="minibanner image-desktop"
                    {...imageDesktop}
                  />
                </div>
              )}
              {video && video?.src && (
                <div className="video-background">
                  <Video
                    {...video}
                    expand={false}
                    width="100%"
                    height="100%"
                  />
                </div>
              )}

              <div className={`content-container ${layoutCompact? 'compact' : 'no-compact'}`}>
                {props["LabelMobile-1"] && props["LabelMobile-1"].label && (
                  <div className="display--mobile">
                    <Label {...props["LabelMobile-1"]} />
                  </div>
                )}

                {props["Text-1"] && props["Text-1"].text && (
                  <Text {...props["Text-1"]} />
                )}

                {props["Text-2"] && props["Text-2"].text && (
                  <div className="superbanner-title">
                    <Text {...props["Text-2"]} />
                  </div>
                )}

                {props["Text-3"] && props["Text-3"].text && (
                  <div className="display--desktop">
                    <Text {...props["Text-3"]} />
                  </div>
                )}

                {props["TextMobile-3"] && props["TextMobile-3"].text && (
                  <div className="display--mobile">
                    <Text {...props["TextMobile-3"]} />
                  </div>
                )}

                {props["Label-1"] && props["Label-1"]?.label && (
                  <div className="display--desktop">
                    <Label {...props["Label-1"]} />
                  </div>
                )}

                <div className="superbanner-price-cont">
                  {props["Price-1"] && props["Price-1"].price && (
                    <Price {...props["Price-1"]} />
                  )}

                  {props["Price-2"] && props["Price-2"].price && (
                    <Price {...props["Price-2"]} />
                  )}
                </div>

                {props["Text-4"] && props["Text-4"].text && (
                  <div className="display--desktop">
                    <Text {...props["Text-4"]} />
                  </div>
                )}

                <div className="display--desktop">
                  {props["Button-1"] && props["Button-1"].href && (
                    <div className="superbanner-button-cont">
                      <Button
                        {...props["Button-1"]}
                        taggingInfo={taggingInfo}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className={`${props?.skeletonClassName}`}></div>
            </div>
          </>
        )}
      </div>
      {/* INJECT_STYLED_JSX_TAG */}
    </>
  );
}


export default SuperBanner;

